import { Injectable } from '@angular/core';
import { IGenomeTime } from 'bz-genome-angular/time-picker/time-picker/bzg-time-picker.component';

@Injectable()
export class GenomeTimeService {

    public getTimeFromDate(date: Date) {
        const time: IGenomeTime = this._getEmptyTime();
        const militaryHour: number = date.getHours();

        if (militaryHour > 0 && militaryHour <= 12) {
            time.hours = militaryHour;
            time.period = 'AM'
            if (militaryHour === 12) {
                time.period = 'PM'
            }
        }
        else if (militaryHour > 12) {
            time.hours = militaryHour - 12;
            time.period = 'PM'
        }
        else if (militaryHour === 0) {
            time.hours = 12;
            time.period = 'AM'
        }

        time.minutes = date.getMinutes();
        time.seconds = date.getSeconds();
        return time;
    }

    public setTimeToDate(date: Date, time: IGenomeTime) {
        if(date && time) {
            let militaryHours: number;

            if (time.period === 'PM' && time.hours < 12) {
                militaryHours = time.hours + 12;
            }
            else if (time.period === 'AM' && time.hours === 12) {
                militaryHours = time.hours - 12;
 }
            else {
                militaryHours = time.hours;
 }

            date.setHours(militaryHours);
            date.setMinutes(time.minutes);
            date.setSeconds(time.seconds);
        }
    }

    private _getEmptyTime() {
		return {
			hours: 12,
			minutes: 0,
			seconds: 0,
			period: 'AM'
		};
	}
}
